import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Decode a JWT payload without an external dependency.
const decodeJwtPayload = (token) => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch (err) {
    console.error("Failed to decode JWT:", err);
    return null;
  }
};

const ProtectedRoute = () => {
  const token = localStorage.getItem("Token");
  const user = localStorage.getItem("user");

  // ❎ If not logged in, clear and redirect to login
  if (!token || !user) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  // ⏳ Check token expiry from the JWT `exp` claim
  const payload = decodeJwtPayload(token);
  const isExpired =
    !payload || (payload.exp && payload.exp < Date.now() / 1000);
  if (isExpired) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  // ✅ If valid, render child routes
  return <Outlet />;
};

export default ProtectedRoute;
